import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  layout: (marginTop: number, overflowY: string | null = null, overflowX: string | null = null) => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
    mt: marginTop,
    overflowY,
    overflowX,
    ...reusables.mainTransition('margin-top', theme.transitions.animation.atomCurve, theme.transitions.time.normal)
  })
};